var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.961H0V-0.00585938Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.00585938V117.623H210.31L256.5 148.383V171.028H233.856L160.312 122.032V171.028H96.1875V122.032L22.6441 171.028H0V148.383L46.19 117.623H0V53.4984H46.19L0 22.7385V-0.00585938H22.6441L96.1875 48.9897V-0.00585938H160.312V48.9897L233.856 -0.00585938H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.00585938H112.219V69.5297H0V101.592H112.219V171.028H144.281V101.592H256.5V69.5297H144.281V-0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938V15.1236L57.5121 53.4984H80.1562L0 -0.00585938ZM256.5 -0.00585938V15.1236L198.988 53.4984H176.344L256.5 -0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.7385V53.4985H210.31L256.5 22.7385Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938V15.1236L57.5121 53.4984H80.1562L0 -0.00585938ZM256.5 -0.00585938V15.1236L198.988 53.4984H176.344L256.5 -0.00585938Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.7385V53.4985H210.31L256.5 22.7385Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.028V155.898L57.5121 117.623H80.1562L0 171.028ZM256.5 171.028V155.898L198.988 117.623H176.344L256.5 171.028Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.777 169.825C449.777 179.444 449.476 199.483 448.374 209.102C444.266 244.07 424.828 278.036 386.153 295.17C340.764 277.235 325.234 244.07 321.126 209.102C320.024 199.483 319.623 189.664 319.623 180.045L319.924 132.853H449.376L449.777 169.825Z",
    fill: "#29DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.374 209.102C448.174 210.705 447.974 212.408 447.773 214.011C442.964 247.176 424.829 279.539 386.153 295.17C342.869 278.136 326.637 247.176 321.828 214.011C321.627 212.408 321.427 210.805 321.227 209.102",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.153 252.186L363.208 209.102H409.097L386.153 252.186Z",
    fill: "#29DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.153 166.118L363.208 209.102H409.097L386.153 166.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.727 280.641C485.024 280.641 492.56 261.217 492.56 237.257C492.56 213.296 485.024 193.872 475.727 193.872C466.431 193.872 458.895 213.296 458.895 237.257C458.895 261.217 466.431 280.641 475.727 280.641Z",
    fill: "#FFBE57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.877 280.641C305.173 280.641 312.71 261.217 312.71 237.257C312.71 213.296 305.173 193.872 295.877 193.872C286.58 193.872 279.044 213.296 279.044 237.257C279.044 261.217 286.58 280.641 295.877 280.641Z",
    fill: "#FFBE57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.153 31.5557L352.688 75.6416H421.321L386.153 31.5557ZM316.116 280.541C316.116 280.541 349.982 310.099 386.153 310.099C422.323 310.099 453.384 280.541 453.384 280.541L461.9 295.17C461.9 295.17 440.058 326.631 386.153 326.631C332.248 326.631 307.6 295.17 307.6 295.17L316.116 280.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.054 127.843C406.035 127.843 421.421 117.391 421.421 104.498C421.421 91.6045 406.035 81.1523 387.054 81.1523C368.074 81.1523 352.688 91.6045 352.688 104.498C352.688 117.391 368.074 127.843 387.054 127.843Z",
    fill: "#A5A5A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTa);
export default __webpack_public_path__ + "static/media/TA.f30aecd36dfdbc32e7b4e447bd379ebe.svg";
export { ForwardRef as ReactComponent };